module.exports = __webpack_public_path__ + "img/enjoy-food.09e74cd4.svg";